import { UCAT_DEFAULT_MODULE_MINUTES } from './getUcatModuleDurationMinutes';

function positiveNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : null;
}

function looksLikeGenericStarTwoClock(examConfig, questions) {
  const payloadMinutes = positiveNumber(examConfig?.duration);
  const n = Array.isArray(questions) ? questions.length : 0;
  if (payloadMinutes == null || n < 1) return false;
  return payloadMinutes === Math.max(1, n * 2);
}

export function getTopicDrillDurationMinutes({
  exam,
  section,
  moduleKey,
  examConfig,
  questions = [],
  lsatPractice = false,
} = {}) {
  const examUpper = String(exam || '').toUpperCase();
  const sectionKey = String(section || '').toLowerCase();
  if (lsatPractice || sectionKey === 'lsat') {
    return 35;
  }

  const essaySeconds = (questions || []).find((q) => positiveNumber(q?.essay_time_limit_seconds))
    ?.essay_time_limit_seconds;
  const fromEssay = positiveNumber(essaySeconds);
  const payloadMinutes = positiveNumber(examConfig?.duration);
  const genericStarTwo = looksLikeGenericStarTwoClock(examConfig, questions);
  const writingPractice = examUpper === 'TARA' && (moduleKey === 'writing' || sectionKey === 'writing');

  if (writingPractice) {
    if (fromEssay != null) return fromEssay / 60;
    if (genericStarTwo || payloadMinutes == null) return 40;
    return payloadMinutes;
  }

  if (payloadMinutes != null) return payloadMinutes;
  if (fromEssay != null) return fromEssay / 60;

  if (examUpper === 'LNAT') {
    if (sectionKey === 'section_b' || sectionKey === 'b') return 40;
    return 95;
  }
  if (examUpper === 'TARA') return 40;
  if (examUpper === 'UCAT') {
    return UCAT_DEFAULT_MODULE_MINUTES[moduleKey] || 22;
  }
  return null;
}
